<template>
  <zkContent leftStyle="width:40%" rightStyle="width:60%"  @contentHeight="setcontentHeight">
    <div slot="left">
     <zk-role-group @menuSelect="menuSelect"></zk-role-group>
    </div>
    <div slot="right">
        <zk-role-user :selectRoleId="selectRoleId"></zk-role-user>
    </div>
  </zkContent>
</template>
<script>
export default {
  name: 'ZkRoleLayout',
  data() {
    return {
      selectRoleId: ''
    }
  },
  methods: {
    menuSelect(id) {
      this.selectRoleId = id
    }
  }
}
</script>
<style scoped lang="less">
// .role_layout_cla {
//   background: #fff;
//   padding: 10px;
//   border-radius: 6px;
// }
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/roleLayout/src/main.vue